// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3Pg_f","list":"BalanceDue_list__1dRM9","listRow":"BalanceDue_listRow__3iLIH","total":"BalanceDue_total__ebWF_"};